import LocalAPI from 'utils/LocalAPI';
import { useDraft } from './useDraft';

// Module scope so useDraft sees stable function identities
const memoDraftStore = {
  load: (excerptID) => LocalAPI.getMemoDraft(excerptID),
  save: (excerptID, text) => LocalAPI.saveMemoDraft(excerptID, text),
  clear: (excerptID) => LocalAPI.clearMemoDraft(excerptID)
};

export function useMemoDraft(excerptID) {
  const { value, setValue, update, persistNow, syncNow, clearDraft } =
    useDraft(excerptID, memoDraftStore);

  return {
    memoText: value,
    setMemoText: setValue,      // state-only; storage untouched
    updateMemoText: update,     // state + debounced persist
    saveDraftNow: persistNow,   // immediate persist of the given text
    syncDraftNow: syncNow,      // immediate persist of the current text
    clearDraft
  };
}
